import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export const schema = Joi.object().keys({
	title: Joi.string().required(),
  description: Joi.string().allow(''),
  chineseTitle: Joi.string().allow(''),
  chineseDescription: Joi.string().allow(''),
  schoolType: Joi.number().integer(),
  suitAgeLower: Joi.number().integer(),
  suitAgeUpper: Joi.number().integer(),
  openHour: Joi.string().allow(''),
  address: Joi.string().allow(''),
  suit_number: Joi.string().allow(''),
  postcode: Joi.string().allow(''),
  city: Joi.string().allow(''),
  province: Joi.string().allow(''),
  country: Joi.string().allow(''),
  timezone: Joi.string().required(),
  currency: Joi.string().required(),
  homepage: Joi.string().allow(''),
  phone: Joi.string().allow(''),
	email: Joi.string().allow(''),
  image: Joi.string().allow(''),
  tags: Joi.array().allow(''),
  enable: Joi.boolean().allow(''),
  categories: Joi.array().allow(''),
  remark: Joi.string().max(500, 'utf8').allow('')
});

export default function registerSchool(schoolInfo) {
  // VALIDATE PARAMS
  // We throw an error if params are not fulfilled.
  let validateResult = Joi.validate(schoolInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

	return new Promise((resolve, reject) => {
		axios.put(APIAddress, {'uri': '/createschool/',
		'method': 'POST',
		'data': JSON.stringify(schoolInfo),
		'token': localStorage.getItem('token') })
		.then((res) => {
			resolve(res.data);
		})
		.catch((err) => {
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/school/registerSchool.js